var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"count-down-wrapper",class:_vm.getClassName()},[_c('span',{staticClass:"num h-num"},[_vm._v(_vm._s(_vm.hour))]),_c('i',[_vm._v("时")]),_c('span',{staticClass:"num m-num"},[_vm._v(_vm._s(_vm.minute))]),_c('i',[_vm._v("分")]),_c('span',{staticClass:"num s-num"},[_vm._v(_vm._s(_vm.second))]),_c('i',[_vm._v("秒")])])
}
var staticRenderFns = []

export { render, staticRenderFns }